export type JSONGETFunc<T> = (url: string) => Promise<T>;
let _f: JSONGETFunc<any> = (_url: string) => {
    return Promise.resolve();
};

export const setJsonGet = (func: JSONGETFunc<any>) => {
    _f = func;
};
export const jsonGet = <T>(url: string): Promise<T> => {
    return _f(url);
};

export const MAX_UPLOAD_FILE_SIZE_IN_MB: number = 50;
export enum MULTER_ERROR {
    FILE_TOO_LARGE = 'FILE_TOO_LARGE',
    WRONG_FILE_TYPE = 'WRONG_FILE_TYPE'
}
export const acceptedUploadFiles = ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf'];
export const acceptedUploadImages = ['image/png', 'image/jpeg', 'image/jpg'];
